
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

import { FeatureToggleService, FeatureToggle } from './feature-toggle.service';

@Injectable()
export class ResolverFeatureToggleService implements Resolve<FeatureToggle> {

	constructor(
		private ftService: FeatureToggleService
	) { }

	async resolve() {
		await this.ftService.updateFeatureToggle();
		return this.ftService.featureToggle;
	}
}



// WEBPACK FOOTER //
// ./src/app/common-services/resolver-feature-toggle.service.ts